export enum CurrencyEnum {
  EUR = "EUR",
}
